import $ from 'jquery'
import 'owl.carousel';

const CAROUSEL_SELECTOR = ".rowl-carousel"

let list = []
let currentIndex = 0

const getCarouselParamsResponsive = (el) => {
  switch (el.dataset.items) {
    case "1":
      return {
        0: {
          items: 1,
        }
      }
    case "2":
      return {
        0: {
          items: 1,
        },
        576: {
          items: 2,
        },
        768: {
          items: 2,
        },
        992: {
          items: 2,
        },
        1200: {
          items: 2,
        },
      }
    case "3":
      return {
        0: {
          items: 1,
        },
        576: {
          items: 2,
        },
        992: {
          items: 3,
        },
      }      
    case "4":
      return {
        0: {
          items: 1,
        },
        576: {
          items: 2,
        },
        768: {
          items: 3,
        },
        992: {
          items: 4,
        },
        1200: {
          items: 4,
        },
      }
    case "8":
      return {
        0: {
          items: 2,
        },
        400: {
          items: 3,
        },
        576: {
          items: 4,
        },
        768: {
          items: 6,
        },
        992: {
          items: 7,
        },
        1200: {
          items: 8,
        },
      } 
    case "10":
      return {
        0: {
          items: 2,
        },
        400: {
          items: 4,
        },
        576: {
          items: 6,
        },
        768: {
          items: 8,
        },
        992: {
          items: 10,
        },
      } 
    default:
      return {
        0: {
          items: 2,
        },
        576: {
          items: 4,
        },
        768: {
          items: 4,
        },
        992: {
          items: 6,
        },
        1200: {
          items: 6,
        },
      }
  }
}
const getCarouselParams = (el) => {
  const autoplay = el.dataset.autoplay == "true" ? true : false
  const autowidth = el.dataset.autowidth ? true : false
  const nav = el.dataset.hideNav ? false : true
  // const sufix = el.dataset.navWhite == "true" ? "_white"  : "_black"
  const sufix = ""
  const loop = el.dataset.loop ? el.dataset.loop !== "false"  : true
  const center = el.dataset.center ? el.dataset.center == "true"  : false
  const margin = el.dataset.margin ? parseInt(el.dataset.margin)  : 30
  const startPosition = el.dataset.openTo ? parseInt(el.dataset.openTo)  : 0
  const autoSpeed = el.dataset.items == 1 ? 500 : 3500
  // const animateOut = el.dataset.items == 1 ? "fadeOut" : null
  // const animateIn = el.dataset.items == 1 ? "fadeIn" : null
  const timeout = el.dataset.timeout ? parseInt(el.dataset.timeout) : 4000
  const stagePadding = el.dataset.stagePadding ? parseInt(window.innerWidth * .1) : 0
  console.log(stagePadding)
  return {
    nav,
    // navText: [
    //   '<img src="/local/images/owl' + sufix + '_prev.svg" alt="poprzedni" />', 
    //   '<img src="/local/images/owl' + sufix + '_next.svg" alt="następny" />'
    // ],
    loop,
    center,
    startPosition,
    margin,
    stagePadding,
    dots: false,
    autoplay,
    // slideTransition: "cubic-bezier(0.445, 0.050, 0.550, 0.950)", //in-out-sine
    // slideTransition: "cubic-bezier(1.000, 0.000, 0.000, 1.000)", //in-out-expo
    slideTransition: "cubic-bezier(.54,0,.51,.99)", //custom
    smartSpeed: 500,
    autoplayTimeout: timeout,
    autoplayHoverPause: false,
    autoplaySpeed: autoSpeed,
    // animateOut: animateOut,
    // animateIn: animateIn,
    autowidth,
    responsive: getCarouselParamsResponsive(el)
  }
}

const initOwlCarousel = (el, index) => {
  // trace("init owl", el)
  let $carousel = $(el)
  $carousel.addClass('owl-carousel')
  $carousel.owlCarousel(getCarouselParams(el))
  list.push($carousel)
}
const destroyOwlCarousel = ($carousel, index) => {
  // trace("destroy carousel", $carousel)
  $carousel.trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded')
  $carousel.find('.owl-stage-outer').children().unwrap()
}

const onRowlClickPrev = (e) => {
  e.preventDefault()
  const trigger = e.currentTarget
  const selector = trigger.getAttribute("href")
  const carousel = document.querySelector(selector)
  if (carousel) {
    $(carousel).trigger("prev.owl.carousel")
  }
}
const onRowlClickNext = (e) => {
  e.preventDefault()
  const trigger = e.currentTarget
  const selector = trigger.getAttribute("href")
  const carousel = document.querySelector(selector)
  if (carousel) {
    $(carousel).trigger("next.owl.carousel")
  }
}
const initOwlNav = () => {
  $("body").on("click", "a.rowl-prev", onRowlClickPrev)
  $("body").on("click", "a.rowl-next", onRowlClickNext)
}
const destroyOwlNav = () => {
  $("body").off("click", "a.rowl-prev", onRowlClickPrev)
  $("body").off("click", "a.rowl-next", onRowlClickNext)
}

export const destroyOwl = () => {
  destroyOwlNav()
  list.forEach(destroyOwlCarousel)
  list = []
}
export const buildOwl = () => {
  const list = [...document.querySelectorAll(CAROUSEL_SELECTOR)]
  list.forEach(initOwlCarousel)
  initOwlNav()
}
